export { useTableAlign } from './use-table-align';
export type { UseTableAlignConfig, TableAlignment } from './use-table-align';
